import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { PersistentNotificationEffects } from "./state/persistent-notification.effects";
import {
  persistentNotificationFeatureKey,
  persistentNotificationReducer,
} from "./state/persistent-notification.reducer";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      persistentNotificationFeatureKey,
      persistentNotificationReducer,
    ),
    EffectsModule.forFeature([PersistentNotificationEffects]),
  ],
})
export class PersistentNotificationModule {}
